/**
 * @generated SignedSource<<74b907751b14d3428974c967b06e46e1>>
 * @relayHash c579d7d60c1c98be9b1e70d9c09624bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c4b72f0c6488e1e579480e28250d5f23967bfee0292f482de71fa508c34f20a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiBrandingQuery } from './uiBrandingQuery.graphql';

const node: PreloadableConcreteRequest<uiBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4c4b72f0c6488e1e579480e28250d5f23967bfee0292f482de71fa508c34f20a",
    "metadata": {},
    "name": "uiBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
